import * as React from 'react';

import { SingedInComponent } from './SingedInComponent';

type IProfileTopRight = {};

export function ProfileTopRight(props: IProfileTopRight) {
  return <SingedInComponent />;
}
